<template>
	<div class="px-md-5">
		<v-layout wrap justify-end>
			<v-flex grow class="items-center">
				<h1 class="text--text" style="opacity: 0.8">Calendário</h1>
			</v-flex>
			<v-flex xs12 md3>
				<v-select
					v-model="filters.department"
					label="Departamento"
					:items="departments"
					return-object
					@input="getCalendar" />
			</v-flex>
			<v-flex shrink class="items-center justify-end">
				<v-menu :close-on-content-click="false" :nudge-width="200" offset-x>
					<v-btn color="primary" slot="activator">
						Filtros
						<v-icon right>filter_list</v-icon>
					</v-btn>
					<v-card>
						<v-list>
							<v-list-tile>
								<v-list-tile-action>
									<v-switch v-model="filters.showColor" :disabled="loading" />
								</v-list-tile-action>
								<v-list-tile-title>Exibir cores</v-list-tile-title>
							</v-list-tile>
							<v-list-tile>
								<v-list-tile-action>
									<v-switch v-model="filters.showNames" :disabled="loading" />
								</v-list-tile-action>
								<v-list-tile-title>Exibir nomes</v-list-tile-title>
							</v-list-tile>
							<template v-if="filters.showNames">
								<v-divider />
								<v-list-tile>
									<v-list-tile-action>
										<v-switch v-model="filters.showInitialDate" :disabled="loading" />
									</v-list-tile-action>
									<v-list-tile-title>Exibir data de início</v-list-tile-title>
								</v-list-tile>
								<v-list-tile>
									<v-list-tile-action>
										<v-switch v-model="filters.groupRestHome" :disabled="loading" @change="newFilter = true" />
									</v-list-tile-action>
									<v-list-tile-title>Agrupar casas de repouso</v-list-tile-title>
								</v-list-tile>
								<v-list-tile v-if="!filters.groupRestHome">
									<v-list-tile-action>
										<v-switch v-model="filters.showRestHome" :disabled="loading || newFilter" />
									</v-list-tile-action>
									<v-list-tile-title>Exibir casa de repouso</v-list-tile-title>
								</v-list-tile>
							</template>
							<v-divider />
							<v-list-tile>
								<v-list-tile-action>
									<v-switch v-model="filters.showDone" :disabled="loading" @change="newFilter = true" />
								</v-list-tile-action>
								<v-list-tile-title>Exibir concluídos</v-list-tile-title>
							</v-list-tile>
							<v-list-tile>
								<v-list-tile-action>
									<v-switch v-model="filters.showBehind" :disabled="loading" @change="newFilter = true" />
								</v-list-tile-action>
								<v-list-tile-title>Exibir bloqueados</v-list-tile-title>
							</v-list-tile>
							<v-list-tile>
								<v-btn block color="primary" :disabled="!newFilter" @click="getCalendar">
									Recarregar
									<v-icon right>sync</v-icon>
								</v-btn>
							</v-list-tile>
						</v-list>
					</v-card>
				</v-menu>
			</v-flex>
		</v-layout>

		<div class="grid">
			<v-progress-linear v-if="saving" indeterminate color="primary" />
			<div v-if="loading" class="loading">
				<v-progress-circular indeterminate color="primary" />
			</div>
			<v-card v-for="(day, i) in calendar.slice(0, 7)" :key="`${day.date}${i}`">
				<div class="q-row flex-center">
					<span class="montserrat text-bold">{{
						day.date | formatDate("dddd")
					}}</span>
				</div>
			</v-card>
			<v-card
				v-for="day in calendar"
				:key="day.date"
				class="day"
				:style="`background: ${!filters.showColor || !day.color ? 'white' : day.color}`">
				<div class="space-between px-1">
					<span class="titulo">{{
						`${
							getCount(day.items) && filters.showNames
								? `Total: ${getCount(day.items)}`
								: ""
						}`
					}}</span>

					<v-tooltip bottom :disabled="!isLogistics || filters.groupRestHome">
						<span slot="activator" class="titulo" :class="{ 'pointer': isLogistics && !filters.groupRestHome }" @click="copiarNomes(day)">
							{{ day.date | formatDate("DD/MMM") }}
						</span>
						<span>Copiar nomes</span>
					</v-tooltip>

				</div>
				<draggable
					v-if="filters.showNames"
					:list="day.items"
					group="day"
					draggable=".draggable"
					class="draggable-container"
					@change="ev => onChange(ev, day)">
					<template v-for="item in day.items">
						<Card
							:key="item.name"
							:class="{ draggable: isDraggable(item) && !disabled && !saving}"
							:item="item"
							:show-rest-home="filters.showRestHome"
							:show-initial-date="filters.showInitialDate"
							:filters="filters"
							:date="day.date"/>
					</template>
				</draggable>
				<h2 v-else class="text-center mb-2">
					{{
						getCount(day.items) ? getCount(day.items) : ""
					}}
				</h2>
			</v-card>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import draggable from 'vuedraggable';
import { departments } from '@Consts/departamentos';
import { ExtraPresenter } from '@Presenter/extra-presenter';
import { copyToClipboard } from '@Util/functions';

import Card from './card';
import mixin from './mixin';

export default {
	name: 'CalendarioKanban',
	components: { draggable, Card },
	mixins: [mixin],
	data: () => ({
		calendar: [],
		filters: {
			showDone: true,
			showColor: true,
			department: null,
			showNames: false,
			showBehind: true,
			showRestHome: false,
			groupRestHome: true,
			showInitialDate: false
		},
		saving: false,
		loading: false,
		disabled: false,
		newFilter: false,
		departments: departments.filter(({ value }) => value !== 'ANY')
	}),
	computed: {
		isLogistics() {
			return this.filters.department.value === 'LOGISTICS';
		}
	},
	created() {
		this.filters.department = this.departments[2];
		const filters = localStorage.getItem('calendar-filters');
		if (filters) {
			this.filters = JSON.parse(filters);
			this.filters.department = this.departments.find(({ value }) => value === this.filters.department.value);
		}
		this.getCalendar();
	},
	beforeDestroy() {
		localStorage.setItem('calendar-filters', JSON.stringify(this.filters));
	},
	methods: {
		isDraggable(item) {
			if (!item.restHome)
				return Boolean(item.id);

			const resp = item.items.some(i => !!i.id);
			if (!resp || resp.length <= 0)
				return false;

			return true;
		},
		resetCalendar() {
			this.calendar = [];
			const lastSunday = moment().startOf('week');
			for (let i = 0; i < 35; i++) {
				this.calendar.push({ date: lastSunday.format('YYYY-MM-DD') });
				lastSunday.add(1, 'days');
			}
		},
		filterFn({ status }) {
			if (!this.filters.showDone && this.isDone(status))
				return false;
			if (!this.filters.showBehind && this.isBehind(status) && !this.isReady(status))
				return false;
			return true;
		},
		getCalendar() {
			this.resetCalendar();
			this.loading = true;
			this.newFilter = false;
			this.$http.get(`calendario?department=${this.filters.department.value}`)
				.then(this.onResponse)
				.finally(() => {
					this.loading = false;
				});
		},
		onResponse(response) {
			const precedence = this.getPrecedence('DELIVERED').reduce(
				(acc, property, i) => {
					acc[property] = i;
					return acc;
				},
				{}
			);
			this.calendar = response.map(day => {
				day.items = (day.items || [])
					.reduce((acc, card) => {
						card.count = (card.items || []).length || 1;
						if (!this.filters.groupRestHome) {
							if (card.restHome) {
								acc.push(...card.items.filter(this.filterFn));
								return acc;
							}
						} else {
							(card.items || []).forEach(item => {
								if (!card.status && item.status)
									card.status = item.status;
								if (item.status && card.status) {
									if (precedence[item.status] > precedence[card.status])
										card.status = item.status;
								}
							});
						}
						if (this.filterFn(card))
							acc.push(card);
						return acc;
					}, []);
				return day;
			});
			this.sort();
			this.setColors();
		},
		onChange(props, day) {
			if (props && props.added) {
				const { element } = props.added;
				let oldDate;
				const items = element.items || [element];
				this.saving = true;
				ExtraPresenter.updateFarmeOSBox(items.reduce((acc, el) => {
					oldDate = el.date;
					if (el.id) {
						acc.push({
							date: day.date,
							id: el.id,
							key: this.filters.department.value
						});
					}
					return acc;
				}, []))
					.then(() => {
						items.forEach(item => {
							item.date = day.date;
						});
					})
					.catch(() => {
						day.items.splice(day.items.findIndex(d => d.id === element.id), 1);
						this.calendar.find(({ date }) => date === oldDate).items.push(element);
					})
					.finally(() => {
						this.saving = false;
						this.sort();
						this.setColors();
					});
			}
		},
		setColors() {
			// Encontra o count max e min para fazer a normalização
			let min = 100000;
			let max = 0;
			this.calendar.forEach(day => {
				if (!day.items || !day.items.length)
					return;
				const count = this.getCount(day.items);
				min = Math.min(min, count);
				max = Math.max(max, count);
			});
			// Faz a normalização para o count ficar entre 0 e 1 e múltiplica por 120 para calcular a cor
			// 0 é vermelho e 120 é verde
			this.calendar.forEach(day => {
				if (day.items && day.items.length) {
					this.$set(
						day,
						'color',
						`hsla(${
							(1.0 - (this.getCount(day.items) - min) / (max - min)) * 120
						}, 100%, 40%, 0.4)`
					);
				} else
					this.$set(day, 'color', 'white');
			});
		},
		sort() {
			this.calendar.forEach(day => {
				(day.items || []).sort((a, b) => {
					if (a.items && b.items)
						return a.name.localeCompare(b.name);
					if (a.items)
						return -1;
					if (b.items)
						return 1;
					return a.name.localeCompare(b.name);
				});
			});
		},
		getCount(items) {
			if (!items)
				return null;
			return items.reduce((sum, item) => sum + (item.count || 1), 0);
		},
		flattenItems(items) {
			return items.reduce(
				(arr, item) => [...arr, ...(item.items || [item])],
				[]
			);
		},
		copiarNomes({ items }) {
			if (!this.isLogistics || this.filters.groupRestHome)
				return;
			const names = items.map(({ name }) => name.trim()).join('\r\n');
			copyToClipboard(names);
		}
	}
};
</script>

<style lang="scss" scoped>
	@media (min-width: 960px) {
		.v-input--switch {
			justify-content: flex-end;
		}
	}

	.grid {
		gap: 0.5rem;
		display: grid;
		position: relative;
		grid-template-columns: repeat(7, 1fr);

		.v-progress-linear {
			z-index: 2;
			top: -25px;
			position: absolute;
			border-radius: 8px;
		}

		.loading {
			position: absolute;
			inset: 0;
			z-index: 5;
			backdrop-filter: blur(3px);
		}

		.day {
			position: relative;
			min-height: 64px;
			padding: 4px;

			.draggable-container {
				height: 100%;
			}
		}

		.titulo {
			font-size: 10px;
		}

		.draggable {
			cursor: grab;
		}
	}
</style>
